import { useCallback } from 'react';
import {
  getCursonPosition,
  calcCursorPosition,
  moveCursorPosition,
} from '../utility/cursorPosition';
import { parseValue, formatValue, SELECTABLE_TYPES } from '../utils';

const useInputChange = props => {
  const { inputRef, prevValueRef, setInputValue, shouldIgnoreCursor, options } = props;

  return useCallback(
    event => {
      const inputValue = event.target.value;
      const parsedValue = parseValue(options, inputValue);

      const isSupportSelection = SELECTABLE_TYPES.test(event.target.type);

      let resultValue;

      if (isSupportSelection) {
        const cursor = getCursonPosition(inputRef);
        const formattedResult = formatValue(
          options,
          inputValue,
          parsedValue,
          prevValueRef.current,
          cursor
        );

        resultValue = formattedResult.value;

        if (resultValue !== inputValue) {
          inputRef.current.value = resultValue;
        }

        if (!shouldIgnoreCursor) {
          const newCursor = calcCursorPosition(inputValue, prevValueRef.current, formattedResult);

          if (resultValue !== inputValue || cursor !== newCursor) {
            moveCursorPosition(inputRef, newCursor);
          }
        }
      } else {
        resultValue = formatValue(options, inputValue, parsedValue).value;
        if (resultValue !== inputValue) {
          inputRef.current.value = resultValue;
        }
      }

      prevValueRef.current = resultValue;
      setInputValue(resultValue);

      if (options.onChange) {
        // именно parsedValue, resultValue отформатировано
        options.onChange(parsedValue);
      }
    },
    [inputRef, prevValueRef, setInputValue, options]
  );
};

export default useInputChange;
